export default __webpack_public_path__ + "static/tile-img-7e1ae9bfcdfe82128c11f8d5078c3eb6.png";